<template>
  <div style="position:absolute;width: 100%; height: 100%;" :style="$store.state.panoViewOverflowHidden?'{overflow:hidden;position: fixed; left: 0; right: 0; top: 0; bottom: 0;}':''" @touchstart="playAudio" :class="{'model-back': $store.state.isModel && !backgroundOpacity}">
    <div id="appContainer" style="position: absolute;width: 100vw; height: 100vh;"></div>
    <router-view v-show="$store.state.showPlugin"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      audioFirstPlay: true,
      backgroundOpacity: false
    }
  },
  created () {
    window._AMapSecurityConfig = {
      securityJsCode: 'fe3618e8a582ce56b98719a36c69bccf'
    }
  },
  mounted () {
    // setTimeout(() => {
    //   let appId = this.$route.params.appId
    //   let name = this.$route.name
    //   window._czc.push(['_trackEvent', appId, name])
    // }, 1000)

    if (this.util.getUrlParam('audio') === 'false') {
      document.getElementById('audioDom').muted = true
    }
    if (this.util.getUrlParam('backgroundopacity')) {
      this.backgroundOpacity = true
    }
    // this.addEvent(window, 'message', fun)
  },
  methods: {
    // 首次点击时触发音乐播放
    playAudio () {
      if (this.audioFirstPlay) {
        document.getElementById('audioDom').play()
        this.audioFirstPlay = false
      }
    },
    addEvent (obj, trigger, fun) {
      if (obj.addEventListener) {
        obj.addEventListener(trigger, fun, false)
      } else if (obj.attachEvent) {
        obj.attachEvent('on' + trigger, fun)
      } else {
        obj['on' + trigger] = fun
      }
    }
  }
}
</script>

<style lang="scss">
  .model-back{
    background: url("./assets/images/r3d/background.jpg") no-repeat 0 0;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue